export interface EmbedIframeProps {
  id: string;
  src: string;
  backgroundColor: string;
  enableAutoHeightEmbed?: boolean;
}

export function EmbedIframe(props: EmbedIframeProps) {
  const iframeAllow = [
    "autoplay",
    "camera",
    "microphone",
    "fullscreen",
    "encrypted-media",
    "picture-in-picture",
    "clipboard-read",
    "clipboard-write",
    "web-share",
  ].join("; ");

  const iframeSandbox = [
    "allow-same-origin",
    "allow-scripts",
    "allow-forms",
    "allow-modals",
    "allow-popups",
    "allow-popups-to-escape-sandbox",
    "allow-downloads",
    "allow-presentation",
    "allow-top-navigation-by-user-activation",
  ];

  const iframeElement = document.createElement("iframe");

  iframeElement.id = props.id;
  iframeElement.src = props.src;
  iframeElement.allow = iframeAllow;
  iframeElement.sandbox.add(...iframeSandbox);
  iframeElement.allowFullscreen = true;
  iframeElement.frameBorder = "0";
  iframeElement.scrolling = "yes";
  iframeElement.style.backgroundColor = props.backgroundColor;
  iframeElement.style.width = "100%";
  if (!props.enableAutoHeightEmbed) {
    iframeElement.style.height = "100%";
  }
  iframeElement.style.flex = "1";
  iframeElement.style.border = "none";

  return iframeElement;
}
